import React from 'react';
import API from "../base/API";
import moment from "moment";
import DeleteButton from "../base/DeleteButton";
import { hasPermission } from "../auth/Auth";
import { translate } from "../base/Translation";

/*eslint no-restricted-globals: 0 */

export default class TestFiles extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            get_files: "/test/file/fetch/all/:test",
            upload_file: "/test/file/upload/:test",
            delete_file: "/test/file/delete/:file"
        });

        this.state = {
            files: []
        };
    }

    fetchData() {
        this.api.request({
            cache: false,
            route: "get_files",
            params: { test: this.props.test.id },
            success: function (response) {
                this.setState({ files: response });
            }.bind(this)
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    upload(evt) {
        if (this.refs.attachment.files.length < 1) {
            return;
        }

        this.api.request({
            cache: false,
            route: "upload_file",
            data: { files: this.refs.attachment.files },
            params: { test: this.props.test.id },
            created: function (response) {
                let files = this.state.files;
                for (let i = 0; i < response.data.length; i++) {
                    const f = response.data[i];
                    files.push(f);
                }
                this.setState({ files });
                window.dispatchEvent(new Event("reloadLog"));
            }.bind(this)
        });
    };

    onDelete() {
        if (!confirm(translate("Ste si istý?"))) {
            return;
        }

        this.currentComponent.api.request({
            cache: false,
            route: "delete_file",
            params: { file: this.file },
            success: function (response) {
                this.currentComponent.fetchData();
            }.bind(this)
        });
    }

    renderUploadForm() {
        if (!hasPermission("TestFileUpload", this.props.test)) {
            return;
        }

        return (
            <div className="row">
                <div className="col-xs-12 col-md-8 col-lg-8">
                    <h4>{translate("Pridať prílohu")}</h4>
                    <div className="input-group">
                        <input className="form-control" type="file" name="attachment" ref="attachment" />
                        <div className="input-group-btn">
                            <button onClick={this.upload.bind(this)} className="btn btn-primary">{translate("Nahrať")}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        let files = this.state.files.map(function (file) {
            return (
                <tr key={file.name}>
                    <td>
                        <a href={file.url} target="_blank" download={true}>{file.name}</a>
                    </td>
                    <td>{moment(file.created.date).format("D.M.Y")}</td>
                    <td>
                        <DeleteButton permission={hasPermission("TestFileDelete", this.props.test)} onClick={this.onDelete.bind({ file: file.id, currentComponent: this })} />
                    </td>
                </tr>
            )
        }.bind(this));

        if (files.length < 1) {
            files = (
                <tr>
                    <td colSpan={3}>{translate("Žiadna príloha nebola nájdená")}</td>
                </tr>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <table className="table table-striped table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>{translate("Názov súboru")}</th>
                                    <th>{translate("Dátum")}</th>
                                    <th>{translate("Možnosti")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {files}
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.renderUploadForm()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/TestFiles.js